const initState = {
  membershipCardsScannerPopupOpen: false,
  membershipCardsScannerAction: null,
  RFIDCardId: null,
  memberGymByMembershipCardId: null
};

const MembershipCardReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_MEMBERSHIP_CARDS_SCANNER_POP_OPEN":
      return {
        ...state,
        membershipCardsScannerPopupOpen: action.payload.data,
        membershipCardsScannerAction: action.payload.action
      };
    case "SET_RFID_CARD_ID_VALUE":
      return {
        ...state,
        RFIDCardId: action.payload.data,
      };
    case "SET_MEMBER_GYM_BY_MEMBERSHIP_CARD_ID":
      return {
        ...state,
        memberGymByMembershipCardId: action.payload.data,
      };
    default:
      return { ...state };
  }
};

export default MembershipCardReducer;
